
/* eslint-disable no-param-reassign */
import axios from 'axios';

// 请求超时时间
axios.defaults.timeout = 10000;

// 请求上下文
axios.defaults.baseURL = '';

// 取消请求的token
let cancel;

const promiseArr = {};


// 允许跨域
axios.defaults.crossDomain = true;

// post
axios.defaults.headers.post['Content-Type'] = 'application/json';

// get
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';

// axios请求拦截器
axios.interceptors.request.use(
  (config) => {
    const { url } = config;
    // 发起请求时，取消掉当前正在进行的相同请求
    if (config.headers) {
      if (promiseArr[config.url]) {
        promiseArr[config.url]('操作取消');
        promiseArr[config.url] = cancel;
      } else {
        promiseArr[config.url] = cancel;
      }
    }
    if (url.includes('cms-api/api/banner/list')) {
      config.headers.token = 'gbtBCnidT+z50GUDThB5AF1p6Xs5i7lAnrFKlBdVFaihGF4ZHSb7VLrDzirL80SWn+msKVCg7vdoy37DXB/8J03Ml9V4U+ycQlnxVUwaySNNLpqDJ5tQQDvk9MQHkClIYDG64vHpQGT8EtQH+Uv644onTtVpLAQuRAdd7k3gRCf'
    }

    // let isHeaderNotHaveToken = false;
    // if (url.indexOf('login/mobileLogin') !== -1) {
    //   isHeaderNotHaveToken = true;
    // }

    return config;
  },
  (error) => Promise.error(error),
);

// // axios响应拦截器
// axios.interceptors.response.use(
//   (config) => {
//     if (config.status === 200) {
//       if (config.data.code === 401) {
//         localStorage.clear();
//         Cookies.remove('seed');
//         Cookies.remove('_token');
//         router.push({ path: '/login' });
//       } else {
//         return config;
//       }
//     } else {
//       return config;
//     }
//   },
//   // 如果返回Status Code为401或403,则跳转到用户中心登录页
//   (error) => {
//     if (error && error.response) {
//       switch (error.response.status) {
//         case 400:
//           error.message = '错误请求';
//           break;
//         case 401:
//           error.message = '未授权，请重新登录';
//           localStorage.clear();
//           Cookies.remove('_token');
//           Cookies.remove('seed');
//           if (window.location.search.indexOf('callbackurl=') !== -1) {
//             const skipurl = unescape(window.location.search.split('callbackurl=')[1]);
//             window.location.href = skipurl;
//           } else {
//             router.push({ path: '/login' });
//             // window.location.href = LOGIN_CENTER;
//           }
//           break;
//         case 403:
//           error.message = '拒绝访问';
//           localStorage.clear();
//           Cookies.remove('_token');
//           if (window.location.search.indexOf('callbackurl=') !== -1) {
//             const skipurl = unescape(window.location.search.split('callbackurl=')[1]);
//             window.location.href = skipurl;
//           } else {
//             // window.location.href = LOGIN_CENTER;
//           }
//           break;
//         case 404:
//           error.message = '请求错误,未找到该资源';
//           break;
//         case 405:
//           error.message = '请求方法未允许';
//           break;
//         case 408:
//           error.message = '请求超时';
//           break;
//         case 500:
//           error.message = '服务器端出错';
//           break;
//         case 501:
//           error.message = '网络未实现';
//           break;
//         case 502:
//           error.message = '网络错误';
//           break;
//         case 503:
//           error.message = '服务不可用';
//           break;
//         case 504:
//           error.message = '网络超时';
//           break;
//         case 505:
//           error.message = 'http版本不支持该请求';
//           break;
//         default:
//           error.message = `连接错误${error.response.status}`;
//       }
//     }
//     return Promise.resolve(error.response);
//   },
// );

/**
 * 封装get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function get(url, params = {}) {
  return axios({
    method: 'get',
    url,
    params,
    withCredentials: true,
  }).then((res) => res.data);
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function post(url, params, config = {}) {
  return axios({
    method: 'post',
    url,
    data: params,
    withCredentials: true,
    ...config,
  }).then((res) => res.data);
}

export { get, post };
